// Importing @stripe/stripe-js injects the Stripe.js script on every page that
// bundles this file, which Stripe's fraud detection relies on. A failure of
// that import-time load only logs a console warning; only a payment form's
// request reports to Bugsnag.
import { loadStripe } from "@stripe/stripe-js"

import { notifyBugsnag } from "src/utils/bugsnag"

export const STRIPE_LOAD_ERROR_MESSAGE =
  "We couldn't load the payment form. Check your connection and try again."

let stripePromise = null

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.PUBLISHABLE_KEY).catch((error) => {
      stripePromise = null
      notifyBugsnag(error)
      throw error
    })
  }

  return stripePromise
}
